(() => {
  'use strict';
  const controllers = new Map();
  const deadlines = new Map();
  const plain = (html) => {
    const node = document.createElement('template');
    node.innerHTML = html;
    return node.content.textContent;
  };
  const pad = (n) => String(n).padStart(2, '0');
  function init(scope) {
    if (controllers.has(scope)) return;
    const abort = new AbortController();
    const signal = abort.signal;
    const intervals = [];
    const each = (selector, fn) => scope.querySelectorAll(selector).forEach(fn);
    const repeat = (fn, ms) => { fn(); intervals.push(setInterval(fn, ms)); };
    each('[data-date-timer]', (node) => {
      const value = node.dataset.dateTimer;
      // Require an explicit timezone, avoiding visitor-dependent deadlines.
      if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(value)) return;
      const end = Date.parse(value);
      if (!Number.isFinite(end)) return;
      node.hidden = false;
      repeat(() => {
        const t = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        node.textContent = `${pad(Math.floor(t / 86400))}:${pad(Math.floor(t / 3600) % 24)}:${pad(Math.floor(t / 60) % 60)}:${pad(t % 60)}`;
      }, 1000);
    });
    each('[data-product-root]', (root) => {
      const data = root.querySelector('[data-variants]');
      const variants = data ? JSON.parse(data.textContent) : [];
      const picker = root.querySelector('[data-variant]');
      const image = root.querySelector('img.hero-image');
      const changeImage = (url, alt) => {
        if (!image || !url) return;
        image.removeAttribute('srcset');
        image.src = url;
        image.alt = alt || '';
      };
      root.querySelectorAll('[data-gallery-image]').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (!image || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          changeImage(link.dataset.galleryImage, link.dataset.alt);
        }, { signal });
      });
      const selectVariant = () => {
        const v = variants.find((item) => String(item.id) === picker.value);
        if (!v) return;
        root.querySelector('[data-price]').textContent = plain(v.money);
        const compare = root.querySelector('[data-compare]');
        const discount = root.querySelector('[data-discount]');
        const onSale = v.compare > v.price;
        compare.hidden = discount.hidden = !onSale;
        compare.textContent = plain(v.compareMoney);
        discount.textContent = onSale ? `−${Math.round((v.compare - v.price) * 100 / v.compare)}%` : '';
        root.querySelectorAll('[data-atc]').forEach((button) => {
          button.disabled = !v.available;
          button.textContent = v.available ? root.dataset.cta : root.dataset.soldOut;
        });
        const stickyPrice = root.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = plain(v.money);
        const stock = root.querySelector('[data-stock]');
        if (stock) {
          stock.hidden = !(v.tracked && v.stock > 0);
          stock.querySelector('[data-stock-count]').textContent = Math.max(0, v.stock);
          stock.querySelector('[data-stock-fill]').style.width = `${Math.min(100, Math.max(0, v.stock * 100 / Number(stock.dataset.capacity)))}%`;
        }
        const quantity = root.querySelector('[data-quantity]');
        quantity.min = v.min;
        quantity.step = v.step;
        if (v.max !== null) quantity.max = v.max; else quantity.removeAttribute('max');
        const current = Number(quantity.value);
        if (current < v.min || (current - v.min) % v.step !== 0 || (v.max !== null && current > v.max)) quantity.value = v.min;
        changeImage(v.image, v.alt);
      };
      if (picker) picker.addEventListener('change', selectVariant, { signal });
      const viewer = root.querySelector('[data-viewers]');
      if (viewer) {
        const low = Math.min(Number(viewer.dataset.min), Number(viewer.dataset.max));
        const high = Math.max(Number(viewer.dataset.min), Number(viewer.dataset.max));
        let count = low;
        repeat(() => {
          if (document.hidden) return;
          count = Math.min(high, Math.max(low, count + Math.floor(Math.random() * 3) - 1));
          viewer.querySelector('[data-viewer-count]').textContent = count;
        }, 6500);
      }
      const timer = root.querySelector('[data-relative-timer]');
      if (timer) {
        const minutes = Number(timer.dataset.minutes);
        const key = `halloween-timer:${root.dataset.sectionId}:${root.dataset.productId}:${minutes}`;
        let end = deadlines.get(key);
        try { if (!end) end = Number(sessionStorage.getItem(key)); } catch (_) { /* Storage can be unavailable. */ }
        if (!Number.isFinite(end) || end <= 0) {
          end = Date.now() + minutes * 60000;
          try { sessionStorage.setItem(key, String(end)); } catch (_) { /* In-memory fallback below. */ }
        }
        deadlines.set(key, end);
        repeat(() => {
          const seconds = Math.max(0, Math.ceil((end - Date.now()) / 1000));
          timer.textContent = `${pad(Math.floor(seconds / 60))}:${pad(seconds % 60)}`;
        }, 1000);
      }
      const sticky = root.querySelector('[data-sticky]');
      const hero = root.querySelector('[data-hero]');
      if (sticky && hero) {
        let pending = false;
        const update = () => {
          pending = false;
          sticky.hidden = !(window.matchMedia('(max-width: 780px)').matches && hero.getBoundingClientRect().bottom <= 0);
        };
        const schedule = () => {
          if (!pending) { pending = true; requestAnimationFrame(() => { if (!signal.aborted) update(); }); }
        };
        window.addEventListener('scroll', schedule, { passive: true, signal });
        window.addEventListener('resize', schedule, { passive: true, signal });
        const observer = new ResizeObserver(schedule);
        observer.observe(hero);
        signal.addEventListener('abort', () => observer.disconnect(), { once: true });
        update();
      }
    });
    controllers.set(scope, () => { abort.abort(); intervals.forEach(clearInterval); });
  }
  const start = () => document.querySelectorAll('.shopify-section').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const cleanup = controllers.get(event.target);
    if (cleanup) cleanup();
    controllers.delete(event.target);
  });
})();
